import CheckRadioButton from '../../../shared/components/forms/CheckRadioButton';

interface Props {
    label: string;
    name: string;
    value?: number | null;
    onChange: (name: string, value: number) => void;
    required?: boolean | null;
}

export default function GenderSelector({
    label,
    name,
    value = 0,
    onChange,
    required = false,
}: Props) {
    return (
        <>
            <label htmlFor=''>{label}</label>
            <div className='d-flex gap-4'>
                <CheckRadioButton
                    name={name}
                    label='Masculino'
                    onChange={(name, value) => onChange(name, Number(value))}
                    checked={value === 1}
                    value={1}
                    radioGroup={'gender'}
                    key='isMale'
                />
                <CheckRadioButton
                    name={name}
                    label='Femenino'
                    onChange={(name, value) => onChange(name, Number(value))}
                    checked={value === 2}
                    value={2}
                    radioGroup={'gender'}
                    key='isFemale'
                />
            </div>
        </>
    );
}
